import * as Immutable from 'immutable';

export const SIM_GRAPH_DEFAULT_STATS = Immutable.List(['sbp', 'dbp', 'co', 'hr']);

// How long (in milliseconds) must the user be viewing a session before it counts as a view?
export const SESSION_VIEW_TIMER = 10000;
